import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { IconWithText } from 'Components';
import history from 'src/history';

const ClearSearch = props => (
  <IconWithText
    onClick={(e) => {
      e.preventDefault();
      history.push(props.to);
    }}
    text={i18n.t('common:Clear Search')}
    textOrientation="before"
    icon="cancel"
    className={props.className}
  />
);

ClearSearch.propTypes = {
  to: PropTypes.string,
  className: PropTypes.string,
};

export default ClearSearch;



// WEBPACK FOOTER //
// ./src/components/Actions/ClearSearch/ClearSearch.jsx